// Доступ к разделам ERP «Бетон» по ролям. Повторяет backend/beton/access.py — менять оба файла вместе.
// Меню строится из этой таблицы, и она же защищает адреса: набрать #/operator вручную нельзя,
// если раздел не положен роли. Окончательную проверку всё равно делает сервер.
import type { Role } from "./ctx";

const DESK: Role[] = ["manager", "dispatcher", "director", "lab"];

export const SECTIONS: Record<string, Role[]> = {
  schedule: DESK,
  week: ["manager", "dispatcher", "director"],
  fleet: ["dispatcher", "manager", "director"],
  shift: ["dispatcher", "manager", "director"],
  stock: ["lab", "dispatcher", "manager", "director"],
  lab: ["lab", "director"],
  operator: ["operator"],
  driver: ["driver"],
  dashboard: ["director"],
  plan: ["manager", "director"],
  reports: ["director", "manager"],
  catalogs: ["manager", "dispatcher", "director", "lab"],
  admin: [],
};

/** Справочники, которые читают не все: клиенты, контакты и объекты (персональные данные). */
const CATALOG_READ: Record<string, Role[]> = {
  customers: ["manager", "dispatcher", "director"],
  contacts: ["manager", "dispatcher", "director"],
  sites: ["manager", "dispatcher", "director"],
  drivers: ["manager", "dispatcher", "director"],
};

export function canOpen(role: Role, section: string): boolean {
  if (role === "admin") return true;
  return (SECTIONS[section] ?? []).includes(role);
}

export function canReadCatalog(role: Role, name: string): boolean {
  if (role === "admin") return true;
  const roles = CATALOG_READ[name];
  return roles ? roles.includes(role) : true;
}

export function home(role: Role): string {
  if (role === "operator") return "/operator";
  if (role === "driver") return "/driver";
  if (role === "director") return "/dashboard";
  return "/schedule";
}
